import type { AsyncData } from '#app';
import type {
  IModelListQueryParamsRequest,
  IModelResponse,
} from '~/services/base/dto/base.dto';
import type {
  IModelCreateScopeMasterRequest,
  IModelScopeMasterResponse,
} from './dto/scope-master.dto';

export class ScopeMasterRepository {
  private api: any;
  private configService: any;
  private llmService: any;

  constructor(api: any, configService: any) {
    const runtimeConfig = useRuntimeConfig();
    this.api = api;
    this.configService = configService;
    this.llmService = runtimeConfig.public.apiLLMService;
  }

  async getScopeMaster(
    params: IModelListQueryParamsRequest
  ): Promise<AsyncData<IModelResponse<IModelScopeMasterResponse[]>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/scope-master`,
      this.configService,
      {
        params,
      }
    );
    return dataResult;
  }

  async getScopeMasterById(
    id: string | number
  ): Promise<AsyncData<IModelResponse<IModelScopeMasterResponse>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/scope-master/${id}`,
      this.configService
    );
    return dataResult;
  }

  async createScopeMaster(
    params: IModelCreateScopeMasterRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/scope-master`,
      this.configService,
      {
        method: 'POST',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }

  async updateScopeMaster(
    params: IModelCreateScopeMasterRequest
  ): Promise<AsyncData<IModelResponse<any>, any>> {
    const dataResult = await this.api(
      `${this.llmService}/v1/scope-master`,
      this.configService,
      {
        method: 'PUT',
        body: {
          data: params,
        },
      }
    );
    return dataResult;
  }
}
